const selectNotificationTimeOptions = [
  { id: 30, name: '30 minutos antes' },
  { id: 60, name: '1 hora antes' },
  { id: 90, name: '1 hora e meia antes' },
];

export default selectNotificationTimeOptions;
